export default __webpack_public_path__ + "static/media/acceleZ.40a5bb7b.svg";